import $ from 'jquery';

export default class Utility {
  /**
   * Fetches a JavaScript file from the server and executes it.
   *
   * @param {string} url      The URL of the resource
   * @returns {*}
   */
  static fetchScript(url: string) {
    return $.getScript(url);
  }
}
